/* =====================================================
   PRAISE GOD
   HEADER V2.4
   Scroll Direction + Announcement Controller
   ===================================================== */

(() => {
  'use strict';

  const initHeader = () => {
    const header = document.querySelector('.section-header');
    const announcement = document.querySelector('.pg-announcement');

    if (!header) return;

    let lastScrollY = window.scrollY;

    const updateHeader = () => {
      const currentScrollY = window.scrollY;

      /* ================================================
         VERY TOP
         Announcement visible
         Header sits underneath announcement
         ================================================ */

      if (currentScrollY <= 10) {
        header.classList.remove('pg-announcement-hidden');
        header.classList.remove('pg-header-scrolling-up');

        if (announcement) {
          announcement.style.transform = 'translateY(0)';
        }

        lastScrollY = currentScrollY;
        return;
      }

      /* ================================================
         AFTER LEAVING TOP
         Announcement disappears
         Header moves to very top
         ================================================ */

      header.classList.add('pg-announcement-hidden');

      if (announcement) {
        announcement.style.transform = 'translateY(-100%)';
      }

      /* ================================================
         SCROLLING UP
         ================================================ */

      if (currentScrollY < lastScrollY) {
        header.classList.add('pg-header-scrolling-up');
      }

      /* ================================================
         SCROLLING DOWN
         ================================================ */

      if (currentScrollY > lastScrollY) {
        header.classList.remove('pg-header-scrolling-up');
      }

      lastScrollY = currentScrollY;
    };

    updateHeader();

    window.addEventListener('scroll', updateHeader, {
      passive: true
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHeader);
  } else {
    initHeader();
  }
})();